import { Route, Redirect, Switch, Prompt, withRouter } from 'react-router'
import { Link, NavLink,BrowserRouter as Router} from 'react-router-dom'
import { connect } from 'react-redux'
import model from './src/model'
import { actions } from './src/actions'
import render from './src/render'
import defaults from './src/defaults'

export default {
  model,
  actions,
  defaults,
  connect,
  render,
  
  Router,
  Route,
  Link,
  NavLink,
  Switch,
  Redirect,
  Prompt,
  withRouter
}

export {
  model,
  actions,
  defaults,
  connect,
  render,

  Router,
  Route,
  Link,
  NavLink,
  Switch,
  Redirect,
  Prompt,
  withRouter
}
